<template>
	<module class="m-gallery m-module" :title="config.title">
		<template #head>
			<ul class="dot flex-center">
				<li v-for="(page, i) in dataList" :key="i" :class="{'z-crt': pageIndex == i}"></li>
			</ul>
		</template>

		<ul class="list">
			<li v-for="(page, i) in dataList" :key="i" class="flex-wrap" :class="[{'z-crt': pageIndex == i, 'z-last': lastPageIndex == i, 'z-dis': disableAn}, `an-${config.animation}`]">
				<div v-for="(item, j) in page" :key="j" class="image flex-column" :size="config.style">
					<div class="flex-grow" :style="{'background-image': `url('${item.image}')`}"></div>
					<p v-if="item.name" class="ellipsis">{{item.name}}</p>
				</div>
			</li>
		</ul>
	</module>
</template>

<script>
	import module from './digital_module.vue'

	export default {
		components: {
			module
		},

		props: {
			id: [Number, String]
		},

		data() {
			return {
				config: {},
				pageIndex: 0,
				lastPageIndex: -1,
				disableAn: false
			}
		},

		computed: {
			dataList() {
				let list = this.config.list ? this.config.list.map(item => item) : [];
				let data = [];
				while (list.length) {
					data.push(list.splice(0, this.config.style));
				}
				return data;
			}
		},
		
		mounted() {
			this.update();
			document.addEventListener('visibilitychange', () => {
				if (document.visibilityState == 'hidden') {
					clearTimeout(this._autoTimer);
					clearTimeout(this._backTimer);
				} else if (document.visibilityState == 'visible') {
					this.lastBack();
					this.autoSwitch();
				}
			});
		},
		
		beforeDestroy() {
			clearTimeout(this._updateTimer);
			clearTimeout(this._autoTimer);
			clearTimeout(this._backTimer);
		},

		methods: {
			update() {
				this.request({
					url: '/digital/getData',
					data: {
						digital_id: this.$parent.digitalId,
						module_id: this.id
					},
					success: data => {
						new Promise(resolve => {
							if (this.config.list && data.childModule.list.length < this.config.list.length) {
								clearTimeout(this._autoTimer);
								clearTimeout(this._backTimer);
								this.config = {};
								this.pageIndex = 0;
								this.lastPageIndex = -1;
								setTimeout(resolve, 100);
							} else {
								resolve();
							}
						}).then(() => {
							this.config = data.childModule;
							this.$nextTick(this.autoSwitch);
							this._updateTimer = setTimeout(this.update, 3600000);
						});
					},
					fail: () => {
						this._updateTimer = setTimeout(this.update, 3600000);
					}
				});
			},

			autoSwitch() {
				if (this.dataList.length < 2) return;
				clearTimeout(this._autoTimer);
				this._autoTimer = setTimeout(() => {
					this.lastPageIndex = this.pageIndex;
					if (++this.pageIndex >= this.dataList.length) {
						this.pageIndex = 0;
					}
					this._backTimer = setTimeout(this.lastBack, 2000);
					this.autoSwitch();
				}, this.config.interval * 1000);
			},

			lastBack() {
				this.disableAn = true;
				this.$nextTick(() => {
					this.lastPageIndex = -1;
					setTimeout(() => {
						this.disableAn = false;
					}, 100);
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-gallery {
		.dot {
			li {
				width: .06rem;
				height: .06rem;
				border-radius: 50%;
				margin-left: .06rem;
				background: rgba(255,255,255,.4);

				&.z-crt {
					width: .08rem;
					height: .08rem;
					background: #00F8C1;
				}
			}
		}

		.list {
			position: absolute;
			left: .14rem;
			right: .14rem;
			top: 0;
			bottom: .14rem;
			overflow: hidden;

			li {
				gap: .14rem;
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;

				&.an-1 {
					transform: translate(calc(100% + .14rem), 0);

					&:not(.z-dis) {
						transition: transform 1.5s ease;
					}

					&.z-crt {
						transform: translate(0, 0);
					}

					&.z-last {
						transform: translate(calc(-100% - .14rem), 0);
					}
				}

				&.an-2 {
					opacity: 0;
					transition: opacity 1s ease;

					&.z-crt {
						z-index: 1;
						opacity: 1;
						transition-delay: .5s;
					}
				}

				.image {
					&[size='1'] {
						width: 100%;
						height: 100%;
					}

					&[size='2'] {
						width: calc((100% - .14rem) / 2);
						height: 100%;
					}

					&[size='4'] {
						width: calc((100% - .14rem) / 2);
						height: calc((100% - .14rem) / 2);
					}

					div {
						border-radius: .04rem;
						background-size: cover;
						background-position: center;
					}

					p {
						box-sizing: border-box;
						width: 100%;
						padding: 0 .06rem;
						margin-top: .12rem;
						line-height: 1.2;
						font-size: .16rem;
						text-align: center;
						color: #B7ECFF;
					}
				}
			}
		}
	}
</style>
